import { Button, Typography } from '@breetometer/components';
import { memo } from 'react';

import type { ISendFiatProps } from './SendFiat.helpers';

const SendFiatComponent = ({ handleCtaClick, isFormCompleted, note }: ISendFiatProps) => (
	<div className='payment-request-form_usdDestination_send-fiat'>
		{note && (
			<div className='payment-request-form_usdDestination_send-fiat_textcontent bg-primary-600 border-dark-navy'>
				<Typography className='color-primary-50'>{note}</Typography>
			</div>
		)}

		<div className='new-btn-cta'>
			<Button
				label='Continue'
				className='payment-request-form_usdDestination_send-fiat_cta primary-hover'
				onClick={handleCtaClick}
				disabled={!isFormCompleted}
				type='button'
			/>
		</div>
	</div>
);

const SendFiat = memo(SendFiatComponent);

export default SendFiat;
